(function () {
    'use strict';

    angular
        .module('reports')
        .factory('reportsService', reportsServiceFactory);

    reportsServiceFactory.$inject = ['$http', 'URLS'];
    function reportsServiceFactory($http, URLS) {
        return {
            fetchScoresReport: fetchScoresReport,
            fetchWagersReport: fetchWagersReport,
            fetchHandicapsReport: fetchHandicapsReport,
            fetchStatsReport: fetchStatsReport
        };

        function fetchScoresReport(groupId, startDate, endDate, scoreType) {
            var url = URLS.fetchScoresReport.format(groupId, toDateString(startDate), toDateString(endDate), scoreType);
            return $http.get(url, { resolveDates: true, jsonReviver: [initialsReviver, stateReviver] });

            function stateReviver(key, value) {
                if (value && angular.isDefined(value.isPosted) && angular.isDefined(value.thru))
                    Object.defineProperty(value, 'state', { get: stateGetter });
                return value;

                function stateGetter() {
                    return value.isPosted ? 'posted' : value.thru == 18 ? 'not-posted' : 'incomplete';
                }
            }
        }

        function fetchWagersReport(groupId, startDate, endDate) {
            var url = URLS.fetchWagersReport.format(groupId, toDateString(startDate), toDateString(endDate));
            return $http.get(url, { resolveDates: true, jsonReviver: initialsReviver });
        }

        function fetchHandicapsReport(groupId, startDate, endDate) {
            var url = URLS.fetchHandicapsReport.format(groupId, toDateString(startDate), toDateString(endDate));
            return $http.get(url, { resolveDates: true, jsonReviver: initialsReviver });
        }

        function fetchStatsReport(groupId, startDate, endDate, scoreType) {
            var url = URLS.fetchStatsReport.format(groupId, toDateString(startDate), toDateString(endDate), scoreType);
            return $http.get(url, { resolveDates: true, jsonReviver: initialsReviver });
        }

        function toDateString(date) {
            return date.toISOString().substr(0, 10);
        }

        function initialsReviver(key, value) {
            // If player object, then add readonly "initials" property
            if (value && angular.isDefined(value.firstName) && angular.isDefined(value.lastName))
                Object.defineProperty(value, 'initials', { get: initialsGetter });
            return value;

            function initialsGetter() {
                return ((value.firstName || '').charAt(0) + (value.lastName || '').charAt(0)) || ' ';
            }
        }
    }
})();